const query = {};

export default query;
